// components/Signup.js
import React, { useEffect, useRef, useState } from "react";
import CustomInput from "../../../../shared/utils/Input";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Snackbar, Alert, Skeleton } from "@mui/material";
import GlobalButton from "../../../../shared/utils/GlobalButton";

export default function Signup() {
  const navigate = useNavigate();
  const serverURL = process.env.REACT_APP_URL;
  const [mode, setMode] = useState("phoneNumber");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [skloading, setSkloading] = useState(true);
  const [name, setName] = useState("");
  const [isPrefilledData, setIsPrefilledData] = useState(false);

  //Condition when params available
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const nameParam = params.get("name");
    const emailParam = params.get("email");

    if (nameParam) setName(nameParam);
    if (emailParam) {
      setEmail(emailParam);
      setIsPrefilledData(true);

      // Validate immediately after setting email
      const domain = emailParam.split("@")[1];
      if (
        emailRegex.test(emailParam) &&
        domain &&
        !restrictedDomains.some((restrictedDomain) =>
          domain.toLowerCase().includes(restrictedDomain),
        )
      ) {
        setIsEmailValid(true);
      } else {
        setIsEmailValid(false);
      }
    }
  }, []);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const emailInputRef = useRef(null);

  useEffect(() => {
    if (emailInputRef.current) {
      emailInputRef.current.focus();
    }
  }, []);

  // Simulated array of existing emails
  const existingEmails = ["user@company.com", "client@business.com"];
  const restrictedDomains = ["gmail.", "yahoo", "hotmail"];
  const validateEmailFormat = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const handleEmailChange = (e) => {
    const enteredEmail = e.target.value;
    setEmail(enteredEmail);

    const domain = enteredEmail.split("@")[1];

    if (
      emailRegex.test(enteredEmail) &&
      domain &&
      !restrictedDomains.some((restrictedDomain) =>
        domain.toLowerCase().includes(restrictedDomain),
      )
    ) {
      setIsEmailValid(true);
    } else {
      setIsEmailValid(false);
    }
  };
  const handlePhoneChange = (e) => {
    e.preventDefault();
    const enteredPhoneNumber = e?.target?.value;
    setPhoneNumber(enteredPhoneNumber);
  };
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSignupClick = async () => {
    if (validateEmailFormat(email) || phoneNumber.length >= 10) {
      setIsLoading(true);

      try {
        const response = await axios.post(`${serverURL}/client/send-otp`, {
          email,
          phoneNumber,
          isPrefilledData,
        });

        setTimeout(() => {
          if (response.data.success) {
            setIsLoading(false);
            setSnackbar({
              open: true,
              message: "OTP sent successfully!",
              severity: "success",
            });

            navigate("/user/otp");

            localStorage.setItem("email", response.data.email);
            localStorage.setItem(
              "phoneNumber",
              response?.data?.data?.phoneNumber,
            );
            localStorage.setItem(
              "name",
              response?.data?.data?.name || "not Getting",
            );
            localStorage.setItem(
              "isClientOnBoarded",
              response.data.isClientOnBoarded,
            );
            localStorage.setItem("role", response.data.role);

            setIsEmailValid(true);
          }
        }, 500);
        if (response.data.success == false) {
          setSnackbar({
            open: true,
            message:
              response?.data?.error ||
              "Failed to send OTP. Please try again later.",
            severity: "error",
          });
        }
      } catch (error) {
        setIsLoading(false);
        setSnackbar({
          open: true,
          message:
            error.response?.data?.error ||
            "Failed to send OTP. Please try again later.",
          severity: "error",
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleEnterPress = () => {
    if (isEmailValid && !isLoading) {
      handleSignupClick();
    }
  };

  return (
    <div className="h-screen flex">
      <div className="relative w-4/12 hidden md:block">
        {skloading && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100vh"
            animation="wave"
          />
        )}
        <img
          src="/assests/clientdashboard/Signupformimg.webp"
          alt="Background"
          className={`h-screen w-full object-fill hidden md:block ${
            skloading ? "hidden" : "block"
          }`}
          onLoad={() => setSkloading(false)}
          onError={() => setSkloading(false)}
        />
      </div>
      <div className="mx-auto flex justify-center items-center md:items-center sm: pl-2 pr-2">
        <div className="max-w-sm w-full">
          <div className="flex justify-center">
            <img
              src="assests/images/pixell dark.png"
              alt="Pixell Logo"
              className="h-12 w-auto"
            />
          </div>
          <h4 className="mt-6 text-start">Access with your work email</h4>

          <p className="mt-2 mb-8 text-start">
            Pixell fills the gap between brands seeking for media marketing and
            clients needing vendors.
          </p>
          {/* <div>
            <img src="assests/clientdashboard/signupGoogle.png" alt="Google" />
          </div> */}
          {/* <div className="relative my-8">
            <div className="absolute inset-0 flex items-center">
              <div
                className="w-full border-t "
                style={{ border: "0.4px solid var(--para-color)" }}
              ></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span
                className="px-2 bg-white sm:mx-0 sm:mt-2 sm:ml-0 mx-[10rem] my-[0.5rem] -mt-[0.5rem]  "
                style={{
                  color: "var(--para-color)",
                  backgroundColor: "var(--secondary-color)",
                }}
              >
                Or
              </span>
            </div>
          </div> */}
          {name && (
            <div className="mb-6">
              <CustomInput
                type="name"
                placeholder="John Doe"
                title=" Name *"
                size="small"
                name="name"
                value={name}
                onEnter={handleEnterPress}
                disabled
                required
                customcolor="var(--heading-color)"
                fontWeight="500"
              />
            </div>
          )}
          <div className="flex bg-gray-100 rounded-lg mb-4 p-1">
            <button
              className={`flex-1 py-2 rounded-md ${
                mode === "email" ? "bg-white shadow" : ""
              }`}
              onClick={() => setMode("email")}
            >
              {`Work Email`}
            </button>

            <button
              className={`flex-1 py-2 rounded-md ${
                mode === "phoneNumber" ? "bg-white shadow" : ""
              }`}
              onClick={() => setMode("phoneNumber")}
            >
              {`Mobile`}
            </button>
          </div>
          <div className="mb-6">
            {mode === "email" ? (
              <CustomInput
                type="email"
                placeholder="email@domain.com"
                title=" Work Email *"
                size="small"
                name="email"
                value={email}
                onChange={handleEmailChange}
                ref={emailInputRef} // Pass the ref to the CustomInput component
                onEnter={handleEnterPress}
                disabled={isPrefilledData} // Disable if email is prefilled from URL
                customcolor="var(--heading-color)"
                fontWeight="500"
              />
            ) : (
              <CustomInput
                type="number"
                placeholder="Enter your phone number"
                title="Mobile Number *"
                size="small"
                name="phoneNumber"
                value={phoneNumber}
                onChange={handlePhoneChange}
                ref={emailInputRef} // Pass the ref to the CustomInput component
                onEnter={handleEnterPress}
                customcolor="var(--heading-color)"
                fontWeight="500"
              />
            )}
          </div>
          {/* <div className=" relative">
            <CustomButton
              type="submit"
              text="Sign up"
              style={{
                backgroundColor:
                  isEmailValid && !isLoading
                    ? "var(--primary-color)"
                    : "var(--light-grey-color)",
                color:
                  isEmailValid && !isLoading
                    ? "var(--secondary-color)"
                    : "var(--heading-color)",
                fontWeight: "600",
              }}
              className="w-full"
              disabled={!isEmailValid || isLoading}
              onClick={handleSignupClick}
            />
            {isLoading && (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", position: "absolute"}}>
                <CircularProgress color="secondary" size={30} />
              </Box>
            )}
          </div> */}
          <GlobalButton
            variant="primary"
            size="large"
            isLoading={isLoading}
            disabled={!(isEmailValid || phoneNumber.length >= 10)}
            onClick={handleSignupClick}
          >
            Sign up
          </GlobalButton>

          <Snackbar
            open={snackbar.open}
            autoHideDuration={7000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert
              onClose={handleSnackbarClose}
              severity={snackbar.severity} // Automatically includes the appropriate icon (success or error)
              sx={{
                backgroundColor:
                  snackbar.severity === "success"
                    ? "var(--third-color)"
                    : "var(--heading-color)", // Green for success, red for error
                color: "var(--secondary-color)", // White text color for readability
              }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
          <p className="mt-8 text-start text-sm ">
            Email us at{" "}
            <a
              href="mailto:admin@pixell.in"
              className="font-medium  hover:text-blue-500"
            >
              admin@pixell.in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
